import { render, staticRenderFns } from "./SliderTeaser.vue?vue&type=template&id=f89c7744&scoped=true"
import script from "./SliderTeaser.vue?vue&type=script&lang=js"
export * from "./SliderTeaser.vue?vue&type=script&lang=js"
import style0 from "./SliderTeaser.vue?vue&type=style&index=0&id=f89c7744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89c7744",
  null
  
)

export default component.exports